import React from 'react';
import { Users, Camera, Star, Award } from 'lucide-react';

const links = [
    {
        icon: Star, // Represents Yelp or general review platform
        url: "https://www.yelp.com/biz/westlake-village-hospice-inc-westlake-village",
        label: "Visit our official Yelp profile",
        title: "Westlake Village Hospice on Yelp"
    },
    {
        icon: Users,
        url: "https://www.facebook.com/westlakevillagehospice/",
        label: "Connect with us on Facebook",
        title: "Westlake Village Hospice on Facebook"
    },
    {
        icon: Camera,
        url: "https://www.instagram.com/westlakevillagehospice/",
        label: "Follow us on Instagram",
        title: "Westlake Village Hospice on Instagram"
    },
    {
        icon: Award, // Represents BBB or Accreditation
        url: "https://www.bbb.org/", // Using main URL as placeholder if specific profile ID isn't provided by user yet
        label: "View our Better Business Bureau profile",
        title: "Accredited by BBB"
    }
];

export default function CommunityLinks({ className = "" }) {
    return (
        <nav aria-label="Community and Accreditations" className={`flex items-center gap-6 ${className}`}>
            {links.map((link, index) => (
                <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.label}
                    title={link.title}
                    className="text-slate-400 hover:text-blue-400 transition-colors duration-300"
                >
                    <link.icon className="w-5 h-5" strokeWidth={1.5} />
                </a>
            ))}
        </nav>
    );
}
